module.exports = __webpack_public_path__ + "media/images/pic/saska/saska_kids_bg-5f380bed1b8e37f71efa3becec10921e.png";